module.exports = __webpack_public_path__ + "img/Al-Jadiriya1.d3ab25ab.png";